import { Box, Stack, Typography, useTheme } from "@mui/material";

function CardItem({
  label,
  content,
  contrast,
}: {
  label: string;
  content: string;
  contrast?: "light" | "dark";
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 1.5,
        bgcolor: contrast === "light" ? theme.palette.primary.light : theme.palette.primary.dark,
        border: "1px solid rgba(120,150,180,0.25)",
        boxShadow: "0 4px 12px rgba(120,150,180,0.08)",
        backdropFilter: "blur(8px)",
        height: "100%",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
        {label && (label.trim() === "Départ" || label.trim() === "Arrivée") && (
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "#00eaff",
              flexShrink: 0,
            }}
          />
        )}
        <Typography
          variant="caption"
          fontWeight={700}
          sx={{
            textTransform: "uppercase",
            fontSize: "0.7rem",
            display: "block",
            color: theme.palette.secondary.light,
          }}
        >
          {label}
        </Typography>
      </Stack>
      <Typography
        variant="body2"
        fontSize="0.813rem"
        fontWeight={600}
        sx={{
          color: "#fff",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {content || "-"}
      </Typography>
    </Box>
  );
}

export default CardItem;
